import UserInfoDropdown from './components/UserInfoDropdown/UserInfoDropdown';
import useDevice from 'hooks/useDevice';
import { Horizontal, StretchSpacer, Vertical } from 'gls';
import { style } from 'typestyle';
import { observer } from 'mobx-react';
import { useLayoutStore } from 'contexts/RootStore.context';
import { colours } from 'styling/colours';
import { PageError } from './components/PageError';

const HeaderDefault = observer(() => {
  const { pageTitle, pageSubTitle, pageError } = useLayoutStore()
  const { isTabletDevice } = useDevice()

  return (
    <Vertical spacing={5} className={PageHeaderStyle(isTabletDevice)} >
      <Horizontal spacing={24} verticalAlign="center">
        <span className='HeaderTitle'>{pageTitle}</span>
        <StretchSpacer />
        {!isTabletDevice && <UserInfoDropdown />}
      </Horizontal>
      {pageSubTitle !== "" && <span className='subHeaderTitle'>{pageSubTitle}</span>}
      <PageError error={pageError} />
    </Vertical>
  );
});

export default HeaderDefault;

export const PageHeaderStyle = (isMobileDevice: boolean) => style({
  marginTop: isMobileDevice ? '50px !important' : '',
  width: "100%",
  position: "relative",
  color: colours.secondaryText,
  fontWeight: "normal",
  textOverflow: "ellipsis",
  marginBottom: isMobileDevice ? '10px' : "30px",
  whiteSpace: "nowrap",
  $nest: {
    ".HeaderTitle": {
      fontSize: isMobileDevice ? '20px' : "38px",
    },
    ".subHeaderTitle": {
      fontSize: "14px",
    },
  }
});